<template>
    <div class="image-marker" >
        <div class="image-marker-container" :class="{'not-upload': !imageUrl}">
            <canvas id="imgcanvas"></canvas>
            <p class="not-upload-tips"><i class="nucfont inuc-tupian"></i>未上传图像</p>
        </div>

        <el-drawer
            :append-to-body="true"
            :modal-append-to-body="true"
            title="选择标注类型"
            class="map-mark-drawer"
            :visible.sync="markDrawer"
            :wrapperClosable="false"
            :show-close="false"
        >
            <div class="drawer-content">
                <el-collapse accordion>
                    <el-collapse-item v-for="(item,pidx) in knowledgeData" :name="item.value" :key="item.value">
                        <template slot="title">
                            {{item.value}}
                        </template>
                        <div>
                            <ul>
                                <li v-for="(item2,sidx) in item.children" :key="item2.value" class="content-item"
                                    :class="{'selected':item2.selected}" @click="markSelectChange(item2,pidx,sidx)">
                                    <span class="item-name">{{item2.value}}</span></li>
                            </ul>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="demo-drawer-footer">
                <el-button style="margin-right: 8px" @click="cancelSelect">取消</el-button>
                <el-button type="primary" :disabled="!markValue" @click="markSelectSave">确认</el-button>
            </div>
        </el-drawer>

    </div>
</template>

<script>
    import {DrBluePrint} from '@/utils/drBluePrint'

    export default {
        name: 'imageMarker',
        props: {
            imageUrl: {
                type: String,
                required: true
            },
            imageMark: {
                type: Array,
                required: true
            },
            disabled: {
                default: false
            }
        },

        data() {
            return {
                markedTangleLength: 0,
                markDrawer: false,
                knowledgeData: [],
                markValue: '',
                markId: '',
            }
        },

        watch: {
            imageUrl() {
                this.fillImage()
            },
        },

        mounted() {
            this.$store.dispatch('getMarkKnowledgeMenu').then(data => {
                // 如果某项没有子菜单，则将自己复制一份作为子菜单
                let _data = JSON.parse(JSON.stringify(data))
                this.knowledgeData = _data.map(item => {
                    if (!item.children || !item.children.length) {
                        item.children = [{
                            id: item.id,
                            value: item.value
                        }]
                    }
                    return item
                })
            })
        },

        methods: {
            // 加载图像信息
            fillImage() {
                let imageData = {
                    url: this.imageUrl,
                    rectangleOptions: this.imageMark
                }

                this.markedTangleLength = this.imageMark.length

                setTimeout(() => {
                    if (!this.drBluePrint) {
                        this.drBluePrint = new DrBluePrint({
                            containerClass: '.image-marker-container'
                        })
                    }

                    this.drBluePrint.setMiddleMouseSelectCallback(this.middleMouseSelectCallback)
                    this.drBluePrint.show(imageData)
                }, 300)
            },

            middleMouseSelectCallback(pos, len) {
                this.markedTangleLength = len

                if (this.disabled) {
                    this.drBluePrint.removeUserMarkedRectangleText(this.markedTangleLength - 1)
                    return this.$message.info('安全图像无需标框')
                }

                this.markDrawer = !this.markDrawer

                this.markValue = ''
                this.markId = ''
                this.knowledgeData.forEach(item => {
                    if (item.children) {
                        item.children.forEach(item2 => {
                            item2.selected = false
                        })
                    }
                })
            },

            getUserMarkedRectanglesInfo() {
                return this.drBluePrint.getUserMarkedRectanglesInfo()
            },

            markSelectChange(data, pidx, sidx) {
                this.knowledgeData.forEach(item => {
                    if (item.children) {
                        item.children.forEach(item2 => {
                            item2.selected = false
                        })
                    }
                })

                this.knowledgeData[pidx].children[sidx].selected = true
                this.$set(this.knowledgeData[pidx].children, sidx, this.knowledgeData[pidx].children[sidx])
                this.markValue = data.value
                this.markId = data.id
            },

            clearMarkInfo() {
                for (let i = 0;i < this.markedTangleLength;i++) {
                    this.drBluePrint.removeUserMarkedRectangleText(0)
                }
                this.markedTangleLength = 0
            },

            // 取消 关闭抽屉
            cancelSelect() {
                this.markDrawer = false
                this.drBluePrint.removeUserMarkedRectangleText(this.markedTangleLength - 1)
            },

            markSelectSave() {
                let color = '#f00'
                this.drBluePrint.addUserMarkedRectangleText(this.markedTangleLength - 1, this.markValue, this.markId, color)
                this.markDrawer = false
            },
        },
    }
</script>

<style lang="scss">
    .image-marker {

        .image-marker-container {


            .not-upload-tips {
                display: none;
            }
        }

        .not-upload {
            background-color: #f5f7fa;
            .not-upload-tips {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: block;
                color: #909399;

                .nucfont {
                    margin-right: 4px;
                    vertical-align: -1px;
                }
            }
        }
    }

    .map-mark-drawer {
        .drawer-content {
            width: 100%;
            height: calc(100% - 51px);
            padding: 24px;
            overflow-y: auto;
        }

        .demo-drawer-footer {
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            border-top: 1px solid #e8e8e8;
            padding: 10px 16px;
            text-align: right;
            background: #fff;
        }

        .content-item {
            padding: 10px 0px 10px 28px;
            cursor: pointer;

            &:hover {
                .item-name {
                    color: #2d8cf0;
                }
            }

            &.selected {
                background-color: #f0faff;

                .item-name {
                    color: #2d8cf0;
                }
            }

            .item-name {
                font-size: 16px;
            }
        }
    }
</style>
